module.exports = __webpack_public_path__ + "static/media/room15SouthWall.f035cbb3.jpg";